"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarType = void 0;
var AbstractComponent_1 = __importDefault(require("../AbstractComponent"));
var constantsSnackbar_1 = require("../../data/constantsSnackbar");
var constantsClasses_1 = require("../../data/constantsClasses");
var SnackbarType;
(function (SnackbarType) {
    SnackbarType["success"] = "success";
    SnackbarType["danger"] = "danger";
})(SnackbarType = exports.SnackbarType || (exports.SnackbarType = {}));
/**
 * Snackbar that can show specific message types
 *
 * @author Kevin Buchholz <kevin.buchholz@wendweb.de>
 */
var Snackbar = /** @class */ (function (_super) {
    __extends(Snackbar, _super);
    function Snackbar(selector, parentSelector) {
        var _this = _super.call(this, selector) || this;
        if (!_this.getElement())
            return _this;
        Snackbar.bar = _this.getElement();
        // Append snack bar to selected parent if selected
        if (parentSelector) {
            _this.parentElement = document.querySelector("[".concat(parentSelector, "]"));
            _this.parentElement.appendChild(Snackbar.bar);
        }
        _this.snackbarElements = _this.getElement().querySelectorAll("[".concat(constantsSnackbar_1.DATA_SNACKBAR_ITEM, "]"));
        return _this;
    }
    /**
     * Trigger snackbar animation
     * @param type
     * @param message
     */
    Snackbar.trigger = function (type, message) {
        var _this = this;
        var items = this.bar.querySelectorAll("[".concat(constantsSnackbar_1.DATA_SNACKBAR_ITEM, "]"));
        this.closeAllItems(items);
        var element = this.getTypeItem(items, type);
        setTimeout(function () {
            element.classList.add(constantsClasses_1.CLASS_OPEN);
            element.querySelector("[".concat(constantsSnackbar_1.DATA_SNACKBAR_TEXT, "]")).innerHTML = message;
            _this.openTimeout = setTimeout(function () {
                element.classList.remove(constantsClasses_1.CLASS_OPEN);
            }, _this.snackBarTimer);
        }, this.transitionTimer);
    };
    /**
     * Return item corresponding to given type
     * @param items
     * @param type
     * @private
     */
    Snackbar.getTypeItem = function (items, type) {
        var item;
        items.forEach(function (element) {
            if (element.dataset.snackbarType == type.toString()) {
                item = element;
            }
        });
        return item;
    };
    /**
     * Close all active snackbar items
     * @private
     */
    Snackbar.closeAllItems = function (items) {
        clearTimeout(this.openTimeout);
        items.forEach(function (element) {
            if (element.classList.contains(constantsClasses_1.CLASS_OPEN)) {
                element.classList.remove(constantsClasses_1.CLASS_OPEN);
            }
        });
    };
    Snackbar.transitionTimer = 300;
    Snackbar.snackBarTimer = 3000;
    return Snackbar;
}(AbstractComponent_1.default));
exports.default = Snackbar;
